import { AnimatePresence, motion } from "framer-motion";
import {
  FaCheckCircle,
  FaExclamationCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaTimes,
} from "react-icons/fa";
import "../Invoicefiles/Toastcontainer.css";

const ICONS = {
  success: FaCheckCircle,
  error: FaExclamationCircle,
  warning: FaExclamationTriangle,
  info: FaInfoCircle,
};

/**
 * ToastContainer — fixed-position notification stack. Pair with useToast().
 * Purely presentational; all state lives in the hook.
 */
function ToastContainer({ toasts, onDismiss }) {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="app-toast-viewport" aria-live="polite" aria-atomic="true">
      <AnimatePresence>
        {toasts.map((t) => {
          const Icon = ICONS[t.variant] || FaInfoCircle;
          return (
            <motion.div
              key={t.id}
              layout
              initial={{ opacity: 0, x: 48, scale: 0.92 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 48, scale: 0.92, transition: { duration: 0.18 } }}
              transition={{ duration: 0.28, ease: "easeOut" }}
              className={`app-toast app-toast-${t.variant}`}
              role="status"
            >
              <span className="app-toast-icon">
                <Icon />
              </span>
              <span className="app-toast-message">{t.message}</span>
              <button
                type="button"
                className="app-toast-close"
                onClick={() => onDismiss(t.id)}
                aria-label="Dismiss notification"
              >
                <FaTimes />
              </button>
              <motion.span
                className="app-toast-timer"
                initial={{ scaleX: 1 }}
                animate={{ scaleX: 0 }}
                transition={{ duration: 4.2, ease: "linear" }}
              />
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}

export default ToastContainer;